import { NestInterceptor, Type, UnprocessableEntityException } from '@nestjs/common';
import { FileInterceptor as NestFileInterceptor } from '@nestjs/platform-express';
import config from 'config';

export const FileInterceptor = (type: string): Type<NestInterceptor> => {
  const options = config.get<any>('multer');
  return NestFileInterceptor('file', {
    dest: config.get('paths.temporary'),
    fileFilter: (request, file, callback) => {
      if (options[type].mimeTypes.includes(file.mimetype)) return callback(null, true);
      return callback(new UnprocessableEntityException([`Unsupported file type: ${file.mimetype}`]), false);
    },
    limits: options[type].limits,
  });
};
